export default "__VITE_ASSET__CjqfXUdi__"